import { Box, Checkbox, Chip, Grid, ListItemText } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendGetRequest,
  sendPostRequest,
  sendPatchRequest,
  allowedOperations,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import { coreStyles } from "../theme/style";

const _ref = {
  uuid: "",
  firstName: "",
  lastName: "",
  role: "",
  actions: [],
  permissions: [],
  email: "",
  active: true,
};

const UserEdit = () => {
  const appStyle = coreStyles();
  const { uuid } = getParams();
  var [user, setUser] = useState(_ref);
  var [auths, setAuths] = useState(null);
  var [emailError, setEmailError] = useState(false);
  const { canCreate } = allowedOperations();

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });
  useEffect(() => {
    sendGetRequest(
      `users?uuid=${uuid}`,
      (loading) => setStatus({ ...{ loading: loading } }),
      (data) => setUser({ ...data })
    );
    return () => setUser(_ref);
    // eslint-disable-next-line
  }, [uuid]);

  const createUpdate = () => {
    if (!uuid) {
      delete user.uuid;
      sendPostRequest(
        "users",
        { ...user, active: true },
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          if (!data.error) setAuths(data.auths);
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    } else {
      user.uuid = uuid;
      sendPatchRequest(
        `users/${uuid}`,
        user,
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const onValueChange = (value, tag) => {
    setUser({ ...user, [tag]: value });
    if (tag === "email") {
      setEmailError(!validateEmail(value));
    }
  };

  const renderChips = (selected) => {
    const MAX_CHIPS = 3;
    if (!selected || selected.length === 0) return null;
    const display = selected.slice(0, MAX_CHIPS);
    const remaining = selected.length - MAX_CHIPS;

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {display.map((value) => (
          <Chip
            key={value}
            label={value}
            onDelete={() =>
              onValueChange(
                selected.filter((v) => v !== value),
                selected === user.permissions ? "permissions" : "actions"
              )
            }
          />
        ))}
        {remaining > 0 && <Chip label={`+${remaining} more`} />}
      </Box>
    );
  };

  return (
    <EditPage
      title={uuid ? `Edit managarial user` : "Add managarial user"}
      status={status}
      btnLabel={canCreate ? (uuid ? "Update Now" : "Add Now") : null}
      onSave={() => createUpdate()}
      validated={
        !emailError &&
        user.firstName &&
        user.lastName &&
        user.email &&
        user.role &&
        (user.actions || []).length &&
        (user.permissions || []).length &&
        !status.loading
      }
      onBack={() => navigate(`${AppRoutes.users}`, true)}
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setUser({ ..._ref });
          navigate(`${AppRoutes.users}`, true);
        }
      }}
    >
      <Grid item md={3} xs={12}>
        <EasyTextEdit
          label="First name"
          placeholder="Given user name"
          type="text"
          id="firstName"
          errorText=""
          textField={true}
          disabled={status.loading}
          value={user.firstName}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={3} xs={12}>
        <EasyTextEdit
          placeholder="Last name"
          label="Last name"
          type="text"
          id="lastName"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={user.lastName}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={6} xs={12}>
        <EasyTextEdit
          placeholder="Valid email address"
          label="Email address"
          type="text"
          textField={true}
          error={emailError}
          id="email"
          errorText={emailError ? "Incorrect email address format" : ""}
          disabled={status.loading}
          value={user.email}
          onChange={onValueChange}
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <FormControl sx={{ minWidth: 100 }} fullWidth>
          <InputLabel id="role-label">Role</InputLabel>
          <Select
            value={user.role}
            label="Role"
            labelId="role-label"
            id="role"
            autoWidth
            onChange={(e) => {
              if (user.role !== e.target.value) {
                onValueChange(e.target.value, "role");
              }
            }}
          >
            {[
              { value: 1, label: "Adminstrator" },
              { value: 2, label: "Editor" },
              { value: 7, label: "Stakeholder" },
            ].map((role) => {
              return (
                <MenuItem value={role.value}>
                  &nbsp;&nbsp;&nbsp;{role.label}
                  <br />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item md={4} xs={12}>
        <FormControl sx={{ minWidth: 200 }} fullWidth>
          <InputLabel id="permissions-label">Permissions</InputLabel>
          <Select
            labelId="permissions-label"
            id="permissions"
            label="Permissions"
            multiple
            value={user.permissions || []}
            onChange={(e) => onValueChange(e.target.value, "permissions")}
            renderValue={(selected) => renderChips(selected)}
          >
            {[
              "Contents",
              "Channels",
              "Games",
              "Accounts",
              "Settings",
              "Analytics",
              "Notifications",
              "Payments",
              "Shows"
            ].map((perm) => (
              <MenuItem key={perm} value={perm}>
                <Checkbox checked={user.permissions?.indexOf(perm) > -1} />
                <ListItemText primary={perm} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item md={4} xs={12}>
        <FormControl sx={{ minWidth: 200 }} fullWidth>
          <InputLabel id="actions-label">Actions</InputLabel>
          <Select
            labelId="actions-label"
            id="actions"
            label="Actions"
            multiple
            value={user.actions || []}
            onChange={(e) => onValueChange(e.target.value, "actions")}
            renderValue={(selected) => renderChips(selected)}
          >
            {["POST", "GET", "PATCH", "DELETE"].map((action) => (
              <MenuItem key={action} value={action}>
                <Checkbox checked={user.actions?.indexOf(action) > -1} />
                <ListItemText primary={action} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item md={12} xs={12}>
        <p className={appStyle.infoText}>
          * <b>Adminstrator</b> can create, view, update and delete anything
          within the system
        </p>
        <p className={appStyle.infoText}>
          * <b>Editor</b> can only create, view and update but can't delete
          anything
        </p>

      </Grid>
    </EditPage>
  );
};

export default UserEdit;
